import {Controller} from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class FlatpickrController extends Controller {
  static values = {
    type: String
  }

  connect() {
    let config = {
      disableMobile: true,

      onOpen: () => {
      },

      onClose: () => {
      },

      onReady: function (selectedDates, dateStr, instance) {
        if (instance.element.dataset.flatpickrTypeValue === "time") {

          const inputs = [instance.hourElement, instance.minuteElement];

          for (const [index, input] of inputs.entries()) {
            input.addEventListener("input", function () {
              input.value = input.value.replaceAll(/\D/g, "").slice(0, 2);
            });

            input.addEventListener("blur", function () {
              if (input.value === "") return;

              let max = index === 0 ? 23 : 59;
              let val = Number.parseInt(input.value, 10);

              val = Math.min(max, Math.max(0, val));

              input.value = val.toString().padStart(2, "0");
            });

          }
        }
      }
    }

    if (this.typeValue === "time") {
      Object.assign(config, {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        altInput: true,
        altFormat: "H:i",
        minuteIncrement: 1
      })
    } else if (this.typeValue === "datetime") {
      Object.assign(config, {
        enableTime: true,
        dateFormat: "Y-m-d h:i K",
        time_24hr: false
      })
    } else {
      Object.assign(config, {
        dateFormat: "Y-m-d"
      })
    }

    this.fp = flatpickr(this.element, config)
  }

  disconnect() {
    document.body.classList.remove("flatpickr-open")
    this.fp?.destroy()
  }
}
